<h6 class="p-2 mb-0" [ngClass]="{ 'teal-background white-font uppercase': showHeader, 'no-header px-3': !showHeader }">
  Prepaid Clinic Supplies
</h6>
<div class="px-2">
  <ngx-loading [show]="loading"></ngx-loading>
  <div *ngIf="prepaidClinicSupplies.length === 0" class="pb-2 px-2">
    <p class="m-0">No prepaid clinic supplies</p>
  </div>
  <div
    class="d-flex grey-two-background mb-2 justify-content-between align-items-center"
    *ngFor="let supply of prepaidClinicSupplies; trackBy: trackByObservationListId"
  >
    <div class="m-2 navy-font">
      <span class="font-weight-bold">{{ supply.supplyName }}</span>
    </div>
    <div class="ml-auto panel-box-column mx-2 bigger font-weight-bold teal-font">
      {{ supply.remainingQuantity | number : '1.0-2' }} {{ supply.unitName }}
    </div>
    <button
      *ngIf="showRedeemButton"
      type="button"
      class="panel-box-button em-btn-green ml-2 py-2"
      (click)="onRedeem(supply)"
      [disabled]="!canRedeem(supply)"
      kendoTooltip
      tooltipClass="em-tooltip"
      title="Redeem"
    >
      <i class="far fa-plus"></i>
    </button>
  </div>
</div>
